import styled from 'styled-components';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import Button from '../../Button';
import { fontSize, radius, space } from '../../../style/utils';

export const MenuPillButton = styled(Button)`
  border: none;
  border-radius: ${radius('pill')};
  padding-left: ${space('md')};

  &:hover {
    border: none;
  }
`;

export const MenuPillChevron = styled(KeyboardArrowDownRoundedIcon)<{
  $isOpen: boolean;
}>`
  font-size: ${fontSize('lg')};
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '-90deg' : '0deg')});
`;
